module.exports = __webpack_public_path__ + "img/health23_7-9-2021.d25e87d7.jpg";